import { useState } from 'react'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import MainLayout from '../../components/layouts/MainLayout'
import { useMainContext } from '../../modules/Dashboard'
import { InvitesCardsListing } from './components/InvitesCardsListing'
import CreateInviteCodeForm from './components/CreateInviteCodeForm'
import useMyInvites from './hooks/useMyInvites'
import CardLayout from '../../components/layouts/CardLayout'
import Banner from './components/Banner'
import HintCard from './components/HintCard'
import DeleteModal from './modals/DeleteModal'
import ModalLayout from '../../components/layouts/ModalLayout'
import MobileModal from '../../components/layouts/MobileModal'

const UserInvitePage = () => {
    const { width } = useWindowSize()
    const { main: { lang, theme } } = useMainContext()
    const {
        inviteCodes,
        inviteCodesLoading,
        allPages,
        activePage,
        onPageChange,
        openDeleteModal,
        deleteModal,
        isDeleting,
        closeDeleteModal,
        finalizeDelete,
    } = useMyInvites()


    const filterState = {
        filterQueries: { page: activePage },
        onPageChange,
    };


    const tableProps = {
        invites: inviteCodes,
        totalPages: allPages,
        state: filterState, // ✅ FIXED
        loading: inviteCodesLoading,
        openDeleteModal,
        lang,
    };
    return (
        <MainLayout>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 w-full mt-5'>
                <div className='lg:col-span-2'>
                    <Banner />
                </div>
                <CardLayout className="!p-6">
                    <CreateInviteCodeForm />
                </CardLayout>
                <div className='hidden lg:block'>
                    <HintCard />
                </div>
                <div className='lg:col-span-2'>
                    <InvitesCardsListing {...tableProps} />
                </div>
            </div>


            {/* Delete Confirmation Modal */}
            {width > 768 ? (
                <ModalLayout open={deleteModal.open} onClose={closeDeleteModal} width={"500px"}>
                    <DeleteModal
                        onClose={closeDeleteModal}
                        onConfirm={finalizeDelete}
                        isLoading={isDeleting}
                        title='delete-invite-code'
                        desc='delete-invite-code-confirm'
                    />
                </ModalLayout>
            ) : (
                <MobileModal isOpen={deleteModal.open} onClose={closeDeleteModal}>
                    <DeleteModal
                        onClose={closeDeleteModal}
                        onConfirm={finalizeDelete}
                        isLoading={isDeleting}
                        title='delete-invite-code'
                        desc='delete-invite-code-confirm'
                    />
                </MobileModal>
            )}
        </MainLayout>
    )
}

export default UserInvitePage